import { Check } from "lucide-react";
import AboutImageCard from "@/components/sections/about/AboutImageCard";

export default function About({ t }) {
  return (
    <section
      id="about"
      className="py-20 sm:py-32 bg-white border-y border-[var(--border)]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 reveal">
          <AboutImageCard locationCaption={t.about.locationCaption} />
        </div>

        <div className="lg:col-span-6 reveal">
          <span className="label-eyebrow">{t.about.label}</span>
          <h2 className="font-heading text-4xl sm:text-5xl mt-3 mb-6">{t.about.title}</h2>
          <p className="text-lg text-[var(--body)] mb-4">{t.about.body1}</p>
          <p className="text-lg text-[var(--body)] mb-8">{t.about.body2}</p>
          <ul className="space-y-3">
            {t.about.bullets.map((b) => (
              <li
                key={b}
                className="flex items-start gap-3"
                data-testid={`about-bullet-${b.slice(0, 24)}`}
              >
                <span className="mt-1 w-6 h-6 rounded-full bg-[var(--secondary)]/15 flex items-center justify-center flex-shrink-0">
                  <Check className="w-3.5 h-3.5 text-[var(--primary)]" strokeWidth={2.5} />
                </span>
                <span className="font-semibold text-[var(--heading)]">{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
